tryBabble = require 'lib/try-babble'
l = require 'lib/localize'
_ = require 'underscore'
counting = require('locale').counting

module.exports = (key, count, data = {}) ->
  args = _.extend { count: String(count) }, data
  tryBabble(['counts', key, counting(count)], args)



// WEBPACK FOOTER //
// ./app/scripts/lib/localize-count.coffee